<template>
    <div class="project-summary-container">
        <div class="row">
            <div class="col-10 img-project-container">
                <img :src="src_img" alt="img" class="img-project" />
            </div>
        </div>
        <h2>{{ title }}</h2>
        <div class="row">
            <div class="col-12 description-project">
                {{ description }}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ProjectSummary",
        props: {
            id:{
                type: String
            },
            title: {
                type: String
            },
            description: {
                type: String
            },
            mainImage: {
                type: String
            }
        },
        data() {
            var src_img = require("../assets/projects/main/" + this.mainImage);
            return {
                src_img
            };
        }
    }
</script>

<style lang="scss">

    .project-summary-container {
        height: 100%;
    }

    .img-project-container {
        text-align: center;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 0.5em;
    }

    .img-project {
        width: 70%;
        height: auto;
        border-radius: 1em;
        transition: transform 0.7s;
        pointer-events: none;
    }

    .description-project {
        overflow: hidden;
    }

    @media (max-width: 960px) {
        .img-project {
            width: 80%;
        }
    }

    @media (max-width: 560px) {
        .img-project {
            width: 90%;
        }
    }

    @media (max-width: 420px) {
        .img-project {
            width: 95%;
        }
    }
</style>